import { node } from 'prop-types'
import { ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Menu } from 'semantic-ui-react'
import esa_image from '../../assets/esa_image.png'
import leftImage from '../../assets/image_left.png'
import rightImage from '../../assets/image_right.png'
import ittiLogo from '../../assets/itti_image.png'
import rosieLogo from '../../assets/rosie_logo.png'
import colourLogo from '../../assets/rosie_logo_color.png'
import uwLogo from '../../assets/uw_image.png'
import './Layout.scss'
function Layout({ children }: { children: ReactNode }) {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className='layout_overflow'>
      <img alt='' src={leftImage} className='layout_left_image' />
      <img alt='' src={rightImage} className='layout_right_image' />
      <Menu pointing secondary size='massive' className='layout_menu'>
        <Menu.Item name='home' data-testid='menu_home' onClick={() => navigate('/')}>
          <img alt='logo' src={rosieLogo} className='layout_rosie_logo' />
        </Menu.Item>
        <Menu.Menu position='right' className='layout_menu_menu'>
          <Menu.Item
            name='Data'
            data-testid='menu_data'
            className='layout_menu_item'
            active={
              !location.pathname.split('/')[1] ||
              (location.pathname.split('/')[1] !== 'about' &&
                location.pathname.split('/')[1] !== 'physics' &&
                location.pathname.split('/')[1] !== 'alerts')
            }
            onClick={() => navigate('/')}
          />
          <Menu.Item
            name='About the project'
            data-testid='menu_about'
            className='layout_menu_item'
            active={location.pathname.split('/')[1] === 'about'}
            onClick={() => navigate('/about/description')}
          />
          <Menu.Item
            name='Physics'
            data-testid='menu_physics'
            className='layout_menu_item'
            active={location.pathname.split('/')[1] === 'physics'}
            onClick={() => navigate('/physics/Heliophysics')}
          />
          <Menu.Item
            name='Alerts'
            data-testid='menu_alerts'
            className='layout_menu_item'
            active={location.pathname.split('/')[1] === 'alerts'}
            onClick={() => navigate('/alerts/general')}
          />
        </Menu.Menu>
      </Menu>
      <div className='layout_screen'>
        <div className='layout_body'>{children}</div>
        <div className='layout_footer_partners'>
          <img src={colourLogo} alt='rosie logo' className='layout_logo logo_margin' />
          <div>
            <b>Project partners:</b>
            <div className='layout_partners_logo'>
              <a href='http://www.astro.uni.wroc.pl/' target='_blank' rel='noreferrer'>
                <img src={uwLogo} alt='Uniwersytet Wrocławski' className='layout_logo' />
              </a>
              <a href='https://www.itti.com.pl/en/home/' target='_blank' rel='noreferrer'>
                <img src={ittiLogo} alt='ITTI' className='layout_logo' />
              </a>
              <a href='https://swe.ssa.esa.int/current-space-weather' target='_blank' rel='noreferrer'>
                <img src={esa_image} alt='ESA' className='layout_logo' />
              </a>
            </div>
          </div>
        </div>
        <div className='layout_footer'>
          <div className='layout_footer_text'>Copyright © 2025 ROSIE. All Rights Reserved</div>
          <div className='layout_footer_text'>
            <a
              href='/policyPrivacyTemplate.pdf'
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: 'white', cursor: 'pointer' }}
            >
              Privacy Policy - Legal Notes
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: node,
}

export default Layout
